<template>
  <div id="app">
    <div class="control_wrapper">
      <ejs-treeview id='treeview' :fields="fields" :showCheckBox='true' :checkedNodes='checkedNodes' :nodeChecked='nodeChecked'></ejs-treeview>
    </div>
  </div>
</template>
<script>

  import Vue from 'vue';
  import {TreeViewPlugin} from "@syncfusion/ej2-vue-navigations";
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const PermissionRepository = RepositoryFactory.get('permissions')

  Vue.use(TreeViewPlugin);
  export default {
    data () {
      return {
          dataSource : [],
          fields: {},
        checkedNodes: []
      }

    },
    async mounted() {
      const {data} = await PermissionRepository.get()
      this.dataSource = data.permission_groups.concat(data.permissions)
      this.fields = { dataSource: this.dataSource, id: 'id', parentID: 'parent_id', text: 'name', hasChildren: 'has_child' }
    },
    methods: {
      nodeChecked: function(args) {
        var treeObj = document.getElementById('treeview').ej2_instances[0];
      }
    }
  }
</script>
<style>

</style>
